<div class="option">
  <label [for]="'dialog-option-' + value" [ngClass]="{ 'option-button': true, 'option-selected': isSelected }">
    <button [id]="'dialog-option-' + value" class="label-button" (click)="selectEvent.emit(value)">
      {{ label | translate }}
    </button>
    @if (isFavouriteable) {
      <button (click)="favouriteEvent.emit(value)" class="favourite-button">
        <i class="material-icons icon">{{ isFavourite ? 'star' : 'star_outline' }}</i>
      </button>
    }
  </label>
</div>
